import type { FieldErrors, UseFormRegister } from "react-hook-form";
import { Input, Label } from "../../components/ui.js";
import type { SiteConfigForm } from "./siteConfigForm.js";

// Shared form fields for site config, reused by Settings and the Setup wizard.
export function SiteConfigFields({
  register,
  errors,
  s3Configured,
}: {
  register: UseFormRegister<SiteConfigForm>;
  errors: FieldErrors<SiteConfigForm>;
  s3Configured?: boolean;
}) {
  return (
    <div className="space-y-5">
      <div>
        <Label>Site name</Label>
        <Input {...register("siteName")} className="max-w-md" />
        {errors.siteName && (
          <p className="mt-1 text-xs text-destructive">
            {errors.siteName.message}
          </p>
        )}
      </div>

      <div className="grid max-w-md grid-cols-1 gap-4 sm:grid-cols-2">
        <div>
          <Label>Stream end grace (min)</Label>
          <Input
            type="number"
            {...register("streamEndGraceMinutes")}
          />
          {errors.streamEndGraceMinutes && (
            <p className="mt-1 text-xs text-destructive">
              {errors.streamEndGraceMinutes.message}
            </p>
          )}
        </div>
        <div>
          <Label>Recording retention (days)</Label>
          <Input
            type="number"
            {...register("recordingRetentionDays")}
          />
          {errors.recordingRetentionDays && (
            <p className="mt-1 text-xs text-destructive">
              {errors.recordingRetentionDays.message}
            </p>
          )}
        </div>
      </div>

      <fieldset className="rounded-xl bg-black/20 p-4 ring-1 ring-inset ring-white/[0.06]">
        <legend className="px-1.5 text-[11px] font-semibold uppercase tracking-wider text-muted-foreground">
          S3 / object storage{" "}
          {s3Configured && (
            <span className="ml-1 text-emerald-400">(configured)</span>
          )}
        </legend>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <div>
            <Label>Endpoint</Label>
            <Input {...register("s3Endpoint")} placeholder="https://s3…" />
          </div>
          <div>
            <Label>Region</Label>
            <Input {...register("s3Region")} placeholder="us-east-1" />
          </div>
          <div>
            <Label>Bucket</Label>
            <Input {...register("s3Bucket")} placeholder="maitv-assets" />
          </div>
          <div>
            <Label>Public asset base</Label>
            <Input
              {...register("s3PublicAssetBase")}
              placeholder="https://cdn.example.com"
            />
          </div>
          <div>
            <Label>Access key</Label>
            <Input
              {...register("s3AccessKey")}
              autoComplete="off"
              placeholder="AKIA…"
            />
          </div>
          <div>
            <Label>Secret key</Label>
            <Input
              {...register("s3SecretKey")}
              type="password"
              autoComplete="new-password"
              placeholder="••••• (write-only)"
            />
          </div>
        </div>
        <p className="mt-2 text-xs text-muted-foreground">
          Secret keys are write-only — they are never echoed back. Leave blank
          to keep the current value.
        </p>
      </fieldset>
    </div>
  );
}
